export default function Dot( {opacity, fill}: {opacity: string, fill: string} ) {
    return (
        <>
            <svg width="5" height="5" xmlns="http://www.w3.org/2000/svg">
                <circle cx="2.5" cy="2.5" r="2.5" fill={fill} opacity={opacity} />
            </svg>
        </>
    );
}
